/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrgTypeSpec } from './orgTypeSpec';


export interface OrgTypeResponseSpec { 
    success?: Array<OrgTypeSpec>;
    failed?: Array<OrgTypeSpec>;
}

